export const memberLifeStylelist =  [
    {
        "Insured_LifeStyleHabit": "Cigarette(s)",
        "PerDay": 0.0,
        "PerWeek": 0.0,
        "PerMonth": 0.0,
        "PastYears": 0.0,
        "selected": false
    },
    {
        "Insured_LifeStyleHabit": "Bidi(s)",
        "PerDay": 0.0,
        "PerWeek": 0.0,
        "PerMonth": 0.0,
       "PastYears": 0.0,
        "selected": false
    },
    {
        "Insured_LifeStyleHabit": "Tobacco Pouches",
        "PerDay": 0.0,
        "PerWeek": 0.0,
        "PerMonth": 0.0,
       "PastYears": 0.0,
        "selected": false
    },
    {
        "Insured_LifeStyleHabit": "Gutka Pouches",
        "PerDay": 0.0,
        "PerWeek": 0.0,
        "PerMonth": 0.0,
        "PastYears": 0.0,
        "selected": false
    },
    {
        "Insured_LifeStyleHabit": "Alcohol(Quantity)",
        "PerDay": 0.0,
        "PerWeek": 0.0,
        "PerMonth": 0.0,
       "PastYears": 0.0,
        "selected": false
    },
    {
        "Insured_LifeStyleHabit": "Drugs(Quantity)",
        "PerDay": 0.0,
        "PerWeek": 0.0,
        "PerMonth": 0.0,
        "PastYears": 0.0,
        "selected": false
    }

]